export const GSPLAT_PARTICLE_MOTION_TYPES = ['chaotic', 'layered-print', 'fractal-orbit'] as const

export type GSplatParticleMotionType = (typeof GSPLAT_PARTICLE_MOTION_TYPES)[number]

export const GSPLAT_LAYERED_PRINT_DIRECTIONS = ['bottom-up', 'top-down'] as const

export type GSplatLayeredPrintDirection = (typeof GSPLAT_LAYERED_PRINT_DIRECTIONS)[number]

export interface GSplatChaoticParticleMotionParams {
  scatterScale: number
}

export interface GSplatLayeredPrintParticleMotionParams {
  layerCount: number
  bandWidth: number
  liftScale: number
  direction: GSplatLayeredPrintDirection
}

export interface GSplatFractalOrbitParticleMotionParams {
  orbitScale: number
  frequency: number
  sweepWidth: number
}

export type GSplatParticleMotion =
  | {
      type: 'chaotic'
      params: GSplatChaoticParticleMotionParams
    }
  | {
      type: 'layered-print'
      params: GSplatLayeredPrintParticleMotionParams
    }
  | {
      type: 'fractal-orbit'
      params: GSplatFractalOrbitParticleMotionParams
    }

export const GSPLAT_PARTICLE_MOTION_DEFAULTS = {
  chaotic: {
    scatterScale: 0.05,
  },
  'layered-print': {
    layerCount: 30,
    bandWidth: 0.06,
    liftScale: 0.08,
    direction: 'bottom-up',
  },
  'fractal-orbit': {
    orbitScale: 0.75,
    frequency: 2,
    sweepWidth: 0.08,
  },
} as const satisfies Record<GSplatParticleMotionType, Record<string, number | string>>

export const GSPLAT_PARTICLE_MOTION_LIMITS = {
  chaotic: {
    scatterScale: { min: 0, max: 1 },
  },
  'layered-print': {
    layerCount: { min: 4, max: 80 },
    bandWidth: { min: 0.01, max: 0.25 },
    liftScale: { min: 0, max: 0.2 },
  },
  'fractal-orbit': {
    orbitScale: { min: 0, max: 1.5 },
    frequency: { min: 0.5, max: 6 },
    sweepWidth: { min: 0.01, max: 0.5 },
  },
} as const
